export default __webpack_public_path__ + "static/media/todo.c8d41b05.jpg";